const getters = {
  isUserLogged: state => {
    return state.userInfo && localStorage.getItem('userInfo')
  }
}

export default getters
